import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { text } from '../helpers';

// Transparent product render; the designation stays real translated text.
// Its affine transform follows the plane of the blank identification label.
export default class EcuHousing extends Component {
  view() {
    const asset = app.forum.attribute('assetsBaseUrl') + '/extensions/bsi-orders/artwork/ecu-aluminium-v2.webp';
    return m("svg", {
      className: "BsiHeroArt-board",
      viewBox: "0 0 1448 1200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      focusable: "false"
    }, m("image", {
      className: "BsiHeroArt-product",
      href: asset,
      width: "1448",
      height: "1086"
    }), m("g", {
      transform: "matrix(.91 .265 -.67 .695 599 259)"
    }, m("text", {
      className: "BsiHeroArt-unitName",
      x: "250",
      y: "147",
      "text-anchor": "middle",
      fill: "#37404a",
      "fill-opacity": ".9",
      "font-size": "112",
      "font-weight": "650",
      "letter-spacing": "7",
      "font-family": "system-ui, sans-serif"
    }, text('home.unit_' + this.attrs.unit))));
  }
}
flarum.reg.add('bsi-orders', 'forum/components/EcuHousing', EcuHousing);